import React from 'react';
import { CalendarIcon } from '@radix-ui/react-icons';
import { format } from 'date-fns';

import { DateSelectionModal } from '../../features/process/components/date-selection.modal';
import { dateShort } from '../../assets/contants/dates-fns';
import { openModal } from '../../core/modal/open-modal';
import { TaskPropertyButton } from '../../features/tasks/components/task-property.button';

interface DateSelectorProps {
  date?: Date | string;
  min?: Date | string;
  max?: Date | string;
  placeholder?: string;
  onUpdate: (value: string) => void;
  field: 'startDate' | 'dueDate';
  disabled?: boolean;
}

export const DateSelector: React.FC<DateSelectorProps> = ({
  date,
  field,
  onUpdate,
  max,
  min,
  placeholder = 'Set date',
  disabled,
}) => {
  const openEditModal = () => {
    openModal(DateSelectionModal, {
      fieldName: field,
      value: date ? format(new Date(date), dateShort) : new Date(),
      onSubmit: onUpdate,
      dateValidator,
    });
  };

  const dateValidator = (value: string) => {
    const date = new Date(value).setUTCHours(0, 0, 0, 0);

    if (min) {
      const minDate = new Date(min);
      minDate.setUTCHours(0, 0, 0, 0);

      return minDate.getTime() <= date;
    }

    if (max) {
      const maxDate = new Date(max);
      maxDate.setUTCHours(0, 0, 0, 0);

      return maxDate.getTime() >= date;
    }

    return true;
  };

  return (
    <TaskPropertyButton
      isDisabled={disabled}
      isActive={!!date}
      onClick={openEditModal}
      icon={<CalendarIcon />}
      label={date ? format(new Date(date), dateShort) : placeholder}
    />
  );
};
